import { HelpItem } from "../../../../Axios/services/help.service";
import { FileText, Video } from "lucide-react";
import React from "react";

export const extractFileName = (url: string): string => {
  try {
    const urlPath = new URL(url).pathname;
    const fullFileName = urlPath.split('/').pop() || '';
    // Remove file extension for display
    const nameWithoutExtension = fullFileName.replace(/\.[^/.]+$/, '');
    return nameWithoutExtension || 'Download';
  } catch {
    return 'Download';
  }
};

export const getTypeIcon = (type: string): React.ReactElement => {
  return type === 'PDF' 
    ? React.createElement(FileText, { size: 20 })
    : React.createElement(Video, { size: 20 });
};

export const getTypeColor = (type: string): string => {
  return type === 'PDF' ? '#0089ce' : '#0089ce';
};

export const openHelpItem = (item: HelpItem, navigate: any): void => {
  if (item.Id) {
    navigate(`/help/${item.Id}`);
  }
};

export const openEmail = (): void => {
  window.open("mailto:connectapp@shi.org.il", "_blank");
};